class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const mvSwiper = new Swiper('.js-home-mv-slider', {
      speed: 500,
      slidesPerView: 1.1,
      spaceBetween: 10,
      centeredSlides: true,
      loop: true,
      autoplay: {
        delay: 5000,  
      },
      breakpoints: {
        851: {
          slidesPerView: 1.58,
        }
      }
    })

    if(isMobile()){

    }else{
      const casesSwiper = new Swiper('.js-home-cases-slider', {
        speed: 500,
        slidesPerView: 1.1,
        spaceBetween: 30,
        loop: false,
        breakpoints: {
          851: {
            slidesPerView: 2.4,
          }
        }
      })
    }
  }
}
